import React, {useState, useEffect, useContext, useRef } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonInput, IonFooter } from '@ionic/react';

import { ShowRoomPicsModal } from './Modal_ShowRoomPics';
import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { AddRoomBookedModal } from './Modal_AddRoom_Booked';
import { UpdateRoomBookedModal } from './Modal_UpdateBookedRoom';
import { EnterCheckInInfoModal } from './Modal_EnterCheckInInfo';

//import '../css/hotelCss.css';
import '../../../css/layout.css';

import { UpdateCheckInDateModal } from './Modal_Update_checkInDate';
import { UpdateCheckOutDateModal } from './Modal_Update_checkOutDate';
import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';

import { format, compareAsc, differenceInDays } from 'date-fns';

import {v4 as uuid} from 'uuid';


export function BookedRoomDetailsModal_multiple(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [merchantPhoneNumber, setMerchantPhoneNumber ] = useState(authenticatedMerchent_context.companyPhoneNumber);
    const [merchantPhoneNumber_mtnMomo, setMerchantPhoneNumber_mtnMomo ] = useState(authenticatedMerchent_context.mtnCompanyPhoneNumber);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [constant_roomID, setConstant_roomID] = useState(props.data.roomID);
    let [constant_roomType, setConstant_roomType] = useState(null);
    let [constant_roomDescription, setConstant_roomDescription] = useState(null);
    let [constant_roomPartNum, setConstant_roomPartNum] = useState(null);
    let [constant_roomPhoneNumber, setConstant_roomPhoneNumber] = useState(null);
    let [constant_address, setConstant_address] = useState(null);
    let [constant_city, setConstant_city] = useState(null);
    let [constant_country, setConstant_] = useState(null);
    let [constant_roomSalePrice, setConstant_roomSalePrice] = useState(0);
    let [constant_originaloRoomPriceTotal, setConstant_originalRoomPriceTotal] = useState(0);

    let [constant_roomPic1, setConstant_roomPic1] = useState(null);
    let [constant_roomPic2, setConstant_roomPic2] = useState(null);
    let [constant_roomPic3, setConstant_roomPic3] = useState(null);
    let [constant_roomPic4, setConstant_roomPic4] = useState(null);
    let [constant_attachment, setConstant_attachment] = useState(null);
    let [constant_roomGuestFirstName, setConstant_roomGuestFirstName] = useState(null);
    let [constant_roomGuestLastName, setConstant_roomGuestLastName] = useState(null);
    let [constant_roomGuestPhoneNumber, setConstant_roomGuestPhoneNumber] = useState(null);
    let [constant_roomGuestEmail, setConstant_roomGuestEmail] = useState(null);
    let [constant_roomGuestPaymentType, setConstant_roomGuestPaymentType] = useState(null);
    let [constant_roomGuestPrice, setConstant_roomGuestPrice] = useState(null);
    let [constant_roomGuestCheckInDateBooked, setConstant_roomGuestCheckInDateBooked] = useState(null);
    let [constant_roomGuestCheckOutDateBooked, setConstant_roomGuestCheckOutDateBooked] = useState(null);
    let [constant_roomGuestCheckInDateActual, setConstant_roomGuestCheckInDateActual] = useState(null);
    let [constant_merchantInvoiceID, setConstant_merchantInvoiceID] = useState(null);
    let [constant_customerInvoiceID, setConstant_customerInvoiceID] = useState(null);
    let [constant_invoiceSentStatus, setConstant_invoiceSentStatus] = useState(null);
    let [constant_transactionID, setConstant_transactionID] = useState(null);
    let [constant_transactionTotalAmount, setConstant_transactionTotalAmount] = useState(null);
    let [constant_transactionStatus, setConstant_transactionStatus] = useState(null);
    let [constant_roomGuestInvoiceAttachment, setConstant_roomGuestInvoiceAttachment] = useState(null);
    let [constant_numOfNights, setConstant_numOfNights] = useState(null);
    let [constant_momo_external_id, setConstant_momo_ExternalId] = useState(null);

    let [roomPicsModal, setRoomPicsModal] = useState(false);

    let [roomID, setRoomID] = useState(null);
    let [roomID_multiple, setRoomID_multiple] = useState([])
    let [roomID_current, setRoomID_current] = useState(null);
    let [roomSalePrice, setRoomSalePrice] = useState(null);
    let [bookedFirstName, setBookedFirstName] = useState(null);
    let [bookedLastName, setBookedLastName] = useState(null);
    let [bookedPhoneNumber, setBookedPhoneNumber] = useState(null);
    let [bookedEmail, setBookedEmail] = useState(null);

    let [bookedStartDate, setBookedStartDate] = useState(null);
    let [bookedStartDate_multiple, setBookedStartDate_multiple] = useState([]);

    let [bookedEndDate, setBookedEndDate] = useState(null);
    let [bookedEndDate_multiple, setBookedEndDate_multiple] = useState([]);

    let [numOfNights, setDateRangeNumberOfNights] = useState(null);
    let [numOfNights_multiple, setDateRangeNumberOfNights_multiple] = useState([]);

    let [customerCheckInPhoneNumber, setCustomerCheckInPhoneNumber] = useState(null);
    
    let [guestPayAmount, setGuestPayAmount] = useState(null);
    let [guestPayAmountTotal, setGuestPayAmountTotal] = useState(null);
    let [guestPayAmount_multiple, setGuestPayAmount_multiple] = useState(null);

    let [showPasswordModal, setShowPasswordModal] = useState(false);
    let [showPasswordModal_refund, setShowPasswordModal_refund] = useState(false);

    let [customerInvoiceID, setCustomerInvoiceID] = useState(null);

    let [checkInModal, setCheckInModal] = useState(false);

    //let [enteredPassword, setEnterPassword] = useState(null);

    let [roomSalePrice_multiple, setRoomSalePrice_multiple] = useState([]);

    let [checkInRoomID_multiple, setCheckInRoomID_multiple] = useState(null);

    let [viewInventoryBookedRoomDetailData, setViewInventoryBookedRoomDetailData] = useState([]);
    let [bookingStatus, setBookingStatus] = useState('bookToCheckIn_multiple');

    let [showInvoiceModal, setViewInvoiceModal] = useState(false);
    let [showAddBookedRoomModal, setShowAddBookedRoomModal] = useState(false);
    let [showUpdateBookedRoomModal, setShowUpdateBookedRoomModal] = useState(false);
    let [showUpdateCheckInDateModal, setShowUpdateCheckInDateModal] = useState(false);
    let [showUpdateCheckOutDateModal, setShowUpdateCheckOutDateModal] = useState(false);

    let [roomGuestInvoiceAttachment, setRoomGuestInvoiceAttachment] = useState(null);

    let [disablePayButton, setDisablePayButton] = useState(false);
    let [displaySetButton, setDisplaySetButton] = useState('inline-block');
    let [displayResetButton, setDisplayResetButton] = useState('none');
    let [disableSetButton, setDisableSetButton] = useState(false);
    let [disableResetButton, setDisableResetButton] = useState(false);

    let [disableRefundButton, setDisableRefundButton] = useState(false);
    let [disableCheckInButton, setDisableCheckInButton] = useState(false);
    let [disableCheckOutButton, setDisableCheckOutButton] = useState(false);

    let [displaySetButton_refund, setDisplaySetButton_refund] = useState('inline-block');
    let [displayResetButton_refund, setDisplayResetButton_refund] = useState('none');
    let [disableSetButton_refund, setDisableSetButton_refund] = useState(false);
    let [disableResetButton_refund, setDisableResetButton_refund] = useState(false);

    let [checkInInvoice_send, setCheckInInvoice_send] = useState(null);
    let [checkInInvoice_sent, setCheckInInvoice_sent] = useState(null);
    let [checkInInvoice_confirmPaid, setCheckInInvoice_confirmPaid] = useState(null);
        let [checkInInvoice_confirmPaid_non_member, setCheckInInvoice_confirmPaid_non_member] = useState(null);
    let [checkInInvoice_paid, setCheckInInvoice_paid] = useState(null);

    let [partialPaymentStatus, setPartialPaymentStatus] = useState(false);

    let [momo_provider, setMomoProvider] = useState('');
    let [momo_financial_transaction_id, setFinancialTransactionId] = useState(''); 
    let [momo_external_id, setExternalId] = useState('');
    let [momo_amount, setAmount] = useState('');
    let [momo_currency, setCurrency] = useState('');
    let [momo_party_id_type, setPartyIdType] = useState('');
    let [momo_party_id, setPartyId] = useState('');
    let [momo_payer_message, setPayerMessage] = useState('');
    let [momo_payee_note, setPayeeNote] = useState('');
    let [momo_pay_status, setPayStatus] = useState('');

    let [momo_pay_status_db, setPayStatus_db] = useState('');

    let [internalReferenceID, setInternalReferenceID] = useState('');

    let [constant_payment_type, setConstant_payment_type] = useState('');

    let [checkInAttachment_ID, setCheckInAttachment_ID ] = useState(() => {

        let noImageFile = new File([''], '/var/www/web/Public/fileServer/merchants/image-not-available.jpg', {
            enctype: 'multipart/form-data',
            type: 'file',
            name: 'xImageFile',
            accept: "image/*",
          });

          return noImageFile;
        
    });

    let enterDepositRef = useRef(0);
    let enterRefundRef = useRef(0);

    let paymentTypeRef = useRef('MTN-MOMO');

    let enterDiscountRef = useRef(0);
    let enterIncreaseRef = useRef(0);

    function handleEnterAttachement() {  

        let noImageFile = new File([''], '/var/www/web/Public/fileServer/merchants/image-not-available.jpg', {
            enctype: 'multipart/form-data',
            type: 'file',
            name: 'xImageFile',
            accept: "image/*",
          });
        
        setCheckInAttachment_ID(noImageFile);
    }

    useEffect(() => {

            /*
            let formData = new FormData();
            formData.append('Tracker', '74113_multiple');
            formData.append('user', acctID);
            //formData.append('xCheckInRoomID', checkInRoomID);
            formData.append('xCheckInRoomID', props.data.roomID);
            formData.append('xBookingID', props.data.bookingID);
        
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74113_multiple',
                    user: acctID,
                    xCheckInRoomID: props.data.roomID,
                    xBookingID: props.data.bookingID,
                    sessionID: sessionID,
    
                }),
            }
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
                
                let roomIDMultiple = [];
                let payAmountTotal = 0.00;
                let numOfNights_multiple = [];
                let checkInDateBooked_multiple = [];
                let checkOutDateBooked_multiple = [];
                let payAmount_multiple = [];
                let roomSalePriceTotal = [];
                let addingUpOriginalTotal = 0;

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    roomIDMultiple.push(cols[0]);

                    let date1 = new Date(cols[20]);
                    let date2 = new Date(cols[21]);
                    let timeDiff;

                    timeDiff = Math.abs(differenceInDays(
                        new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                        new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                      ));
                    //let calcNumberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24)); 

                    numOfNights_multiple.push(timeDiff);

                    setBookedStartDate(date1);
                    checkInDateBooked_multiple.push(date1.toISOString().substr(0, 10));

                    setBookedEndDate(date2);
                    checkOutDateBooked_multiple.push(date2.toISOString().substr(0, 10));

                    if(date1.getDate() == date2.getDate())
                    {
                        setDateRangeNumberOfNights(1);
                        //setGuestPayAmount(parseFloat(cols[19]*1).toFixed(2));
                        timeDiff = 1;
                        payAmountTotal = parseFloat(Number(payAmountTotal) + Number(cols[19]*timeDiff)).toFixed(2);

                        payAmount_multiple.push(cols[8]);
                    }
                    else
                    {
                        setDateRangeNumberOfNights(timeDiff);
                        //setGuestPayAmount(parseFloat(cols[19]*timeDiff).toFixed(2));
                        payAmountTotal = parseFloat(Number(payAmountTotal) + Number(cols[19]*timeDiff)).toFixed(2);

                        payAmount_multiple.push(cols[8]);
                    }

                    if(cols[25] == 'N/A')
                    {
                        
                        if(cols[28] == "C" && (parseFloat(payAmountTotal).toFixed(2) - parseFloat(cols[27]*1).toFixed(2)) == 0.00)
                        {

                            setDisableCheckInButton(false);
                            setBookingStatus('bookToCheckIn_depositPaid_multiple');
                            
                            setCheckInInvoice_send('none');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_confirmPaid_non_member('none');
                            setCheckInInvoice_paid('inline-block');
                        }
                        else if(cols[28] == "C" && (parseFloat(payAmountTotal).toFixed(2) - parseFloat(cols[27]*1).toFixed(2)) > 0.00)
                        {

                            setDisableCheckInButton(false);
                            setBookingStatus('bookToCheckIn_depositPaid_multiple');

                            setCheckInInvoice_send('inline-block');
                            setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
                        else
                        {
                            setCheckInInvoice_send('inline-block');
                            setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
        
                    }
                    
                    else if(cols[25] == 'PR')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('inline-block');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'R_PC')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('inline-block');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'C')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_confirmPaid_non_member('none');
                        setCheckInInvoice_paid('inline-block');
        
                    }

                    //roomID: cols[0],
                    //roomType: cols[1],
                    //roomDescription: cols[2],
                    //roomPartNum: cols[3],
                    setConstant_roomPhoneNumber(cols[4]);
                    //address: cols[5],
                    //city: cols[6],
                    //country: cols[7],
                    //setConstant_roomSalePrice(cols[8]);
                    roomSalePriceTotal.push(cols[8]);
                    addingUpOriginalTotal += parseFloat(cols[8])*timeDiff;
                    //roomPic1: cols[9],
                    //roomPic2: cols[10],
                    //roomPic3: cols[11],
                    //roomPic4: cols[12],
                    //attachment: cols[13],
                    setConstant_roomGuestFirstName(cols[14]);
                    setConstant_roomGuestLastName(cols[15]);
                    setConstant_roomGuestPhoneNumber(cols[16]);
                    setConstant_roomGuestEmail(cols[17]);
                    setConstant_roomGuestPaymentType(cols[18]);
                    //roomGuestPrice: parseFloat(cols[19]).toFixed(2),
                    setConstant_roomGuestCheckInDateBooked(cols[20]);
                    setConstant_roomGuestCheckOutDateBooked(cols[21]);
                    //roomGuestCheckInDateActual: cols[22],
                    setConstant_merchantInvoiceID(cols[23]);
                    setConstant_customerInvoiceID(cols[24]);
                    //setConstant_invoiceSentStatus: cols[25],
                    setConstant_transactionID(cols[26]);
                    setConstant_transactionTotalAmount(parseFloat(cols[27]*1).toFixed(2));
                    //transactionStatus: cols[28],
                    //roomGuestInvoiceAttachment: cols[29],
                    //numOfNights: timeDiff,
                    setPayStatus_db(cols[36])
                    setConstant_momo_ExternalId(cols[31]);
                    setConstant_payment_type(cols[37]);

                    setViewInventoryBookedRoomDetailData((prevViewInventoryOccupiedRoomDetailData) => {
                        return prevViewInventoryOccupiedRoomDetailData.concat({
                            roomID: cols[0],
                            roomType: cols[1],
                            roomDescription: cols[2],
                            roomPartNum: cols[3],
                            roomPhoneNumber: cols[4],
                            address: cols[5],
                            city: cols[6],
                            country: cols[7],
                            roomSalePrice: parseFloat(cols[8]).toFixed(2),
                            roomPic1: cols[9],
                            roomPic2: cols[10],
                            roomPic3: cols[11],
                            roomPic4: cols[12],
                            attachment: cols[13],
                            roomGuestFirstName: cols[14],
                            roomGuestLastName: cols[15],
                            roomGuestPhoneNumber: cols[16],
                            roomGuestEmail: cols[17],
                            roomGuestPaymentType: cols[18],
                            roomGuestPrice: parseFloat(cols[19]).toFixed(2),
                            roomGuestCheckInDateBooked: cols[20],
                            roomGuestCheckOutDateBooked: cols[21],
                            roomGuestCheckInDateActual: cols[22],
                            merchantInvoiceID: cols[23],
                            customerInvoiceID: cols[24],
                            invoiceSentStatus: cols[25],
                            transactionID: cols[26],
                            transactionTotalAmount: parseFloat(cols[27]*1).toFixed(2),
                            transactionStatus: cols[28],
                            momo_provider: cols[29],
                            momo_financial_transaction_id: cols[30],
                            momo_external_id: cols[31],
                            momo_amount: cols[32],
                            momo_party_id: cols[33],
                            momo_payer_message: cols[34],
                            momo_payee_note: cols[35],
                            momo_pay_status: cols[36],
                            payment_type: cols[37],
                            roomGuestInvoiceAttachment: cols[38],
                            internalReferenceID: cols[39],
                            numOfNights: timeDiff,
                        })
                    });
                    
                    setCustomerCheckInPhoneNumber(cols[16]);
                    setRoomSalePrice(parseFloat(cols[19]).toFixed(2));
                    setInternalReferenceID(cols[39]);
                }    

                setRoomID_multiple(roomIDMultiple);
                setGuestPayAmountTotal(payAmountTotal);
                setGuestPayAmount_multiple(payAmount_multiple);
                setDateRangeNumberOfNights_multiple(numOfNights_multiple);
                setBookedStartDate_multiple(checkInDateBooked_multiple);
                setBookedEndDate_multiple(checkOutDateBooked_multiple);

                setConstant_roomSalePrice(roomSalePriceTotal);
                setConstant_originalRoomPriceTotal(addingUpOriginalTotal);

            })
    }, []);


    function onSubmitNewDateHandler(e)
    {
        //setViewInventoryBookedRoomDetailData([]);


        /*let formData = new FormData();
        formData.append('user', acctID);
        if(roomID_current == null)
        {
            formData.append('xCheckInRoomID', props.data.roomID);
        }
        else
        {
            formData.append('xCheckInRoomID', roomID_current);
        }
        formData.append('xBookingID', props.data.bookingID);
        */

        //alert("in onSubmitNewDateHandler ");
        //alert(roomID_current);
        //alert(props.data.roomID);
        //alert(props.data.roomID_current);

        let checkInRoomID = '';
        let Tracker = '';
        let startDateRange = '';
        let endDateRange = '';
        let currentDate = '';
        let checkInNumberOfNights = '';

        if(roomID_current == null)
        {
            checkInRoomID = props.data.roomID;
        }
        else
        {
            checkInRoomID = roomID_current;
        }

        if(bookingStatus == "bookToCheckIn_multiple")
        {
            if(e[0] == 'IN')
            {
                let date1 = new Date(new Date(e[1]));
                let date2 = new Date(new Date(bookedEndDate));
                let timeDiff;


                timeDiff = Math.abs(differenceInDays(
                    new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                    new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                  ));
                
        
                setBookedStartDate(date1);
                setBookedEndDate(date2);
                setDateRangeNumberOfNights(timeDiff);

                /*
                formData.append('Tracker', '74113_U_IN_unpaid');
                formData.append('xStartDateRange', date1.toISOString().substr(0, 10));
                formData.append('xEndDateRange', date2.toISOString().substr(0, 10));
                formData.append('xCheckInNumberOfNights', timeDiff);
                */

                Tracker = '74113_U_IN_unpaid';
                startDateRange = date1.toISOString().substr(0, 10);
                endDateRange = date2.toISOString().substr(0, 10);
                checkInNumberOfNights = timeDiff;
            }
            else if(e[0] == 'OUT')
            {
                let date1 = new Date(new Date(bookedStartDate));
                let date2 = new Date(new Date(e[1]));
                let timeDiff;

                timeDiff = Math.abs(differenceInDays(
                    new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                    new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                  ));
        
                setBookedStartDate(date1);
                setBookedEndDate(date2);
                setDateRangeNumberOfNights(timeDiff);

                /*
                formData.append('Tracker', '74113_U_OUT_unpaid');
                formData.append('xStartDateRange', date1.toISOString().substr(0, 10));
                formData.append('xEndDateRange', date2.toISOString().substr(0, 10));
                formData.append('xCheckInNumberOfNights', timeDiff); 
                */

                Tracker = '74113_U_OUT_unpaid';
                startDateRange = date1.toISOString().substr(0, 10);
                endDateRange = date2.toISOString().substr(0, 10);
                currentDate = new Date(Date.now() + 86400000).toISOString().substring(0, 10);
                checkInNumberOfNights = timeDiff;
            }
        }
        else if(bookingStatus == "bookToCheckIn_depositPaid_multiple")
        {
            if(e[0] == 'IN')
            {
                let date1 = new Date(new Date(e[1]));
                let date2 = new Date(new Date(bookedEndDate));
                let timeDiff;

 
                timeDiff = Math.abs(differenceInDays(
                    new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                    new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                  ));
        
                setBookedStartDate(date1);
                setBookedEndDate(date2);
                setDateRangeNumberOfNights(timeDiff);

                /*
                formData.append('Tracker', '74113_U_IN');
                formData.append('xStartDateRange', date1.toISOString().substr(0, 10));
                formData.append('xEndDateRange', date2.toISOString().substr(0, 10));
                formData.append('xCheckInNumberOfNights', timeDiff);
                */

                Tracker = '74113_U_IN';
                startDateRange = date1.toISOString().substr(0, 10);
                endDateRange = date2.toISOString().substr(0, 10);
                checkInNumberOfNights = timeDiff;
            }
            else if(e[0] == 'OUT')
            {
                let date1 = new Date(new Date(bookedStartDate));
                let date2 = new Date(new Date(e[1]));
                let timeDiff;


                timeDiff = Math.abs(differenceInDays(
                    new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                    new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                  ));
        
                setBookedStartDate(date1);
                setBookedEndDate(date2);
                setDateRangeNumberOfNights(timeDiff);

                /*
                formData.append('Tracker', '74113_U_OUT'); 
                formData.append('xStartDateRange', date1.toISOString().substr(0, 10));
                formData.append('xEndDateRange', date2.toISOString().substr(0, 10));
                formData.append('xCheckInNumberOfNights', timeDiff);
                */

                Tracker = '74113_U_OUT';
                startDateRange = date1.toISOString().substr(0, 10);
                endDateRange = date2.toISOString().substr(0, 10);
                currentDate = new Date(Date.now() + 86400000).toISOString().substring(0, 10);
                checkInNumberOfNights = timeDiff;
            }
        }


        /*
        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xCheckInRoomID: checkInRoomID,
                xBookingID: props.data.bookingID,
                xStartDateRange: startDateRange,
                xEndDateRange: endDateRange,
                xCurrentDateRange: currentDate,
                xCheckInNumberOfNights: checkInNumberOfNights,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

//            alert(data);

            let rows = data.toString().split('~~~');
                
                let roomIDMultiple = [];
                let payAmountTotal = 0.00;
                let numOfNights_multiple = [];
                let checkInDateBooked_multiple = [];
                let checkOutDateBooked_multiple = [];
                let payAmount_multiple = [];

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    roomIDMultiple.push(cols[0]);

                    let date1 = new Date(cols[21]);
                    let date2 = new Date(cols[22]);
                    let timeDiff;

                    timeDiff = Math.abs(differenceInDays(
                        new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                        new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                      ));

                    setBookedStartDate(date1);
                    checkInDateBooked_multiple.push(date1);

                    setBookedEndDate(date2);
                    checkOutDateBooked_multiple.push(date2);

                    if(date1.getDate() == date2.getDate())
                    {
                        setDateRangeNumberOfNights(1);
                        //setGuestPayAmount(parseFloat(cols[19]*1).toFixed(2));
                        timeDiff = 1;
                        payAmountTotal = parseFloat(Number(payAmountTotal) + Number(cols[19]*timeDiff)).toFixed(2);
                    }
                    else
                    {
                        setDateRangeNumberOfNights(timeDiff);
                        //setGuestPayAmount(parseFloat(cols[19]*timeDiff).toFixed(2));
                        payAmountTotal = parseFloat(Number(payAmountTotal) + Number(cols[19]*timeDiff)).toFixed(2);
                    }

                    if(date1.getDate() == date2.getDate())
                    {
                        setDateRangeNumberOfNights(1);
                        //setGuestPayAmount(parseFloat(cols[19]*1).toFixed(2));
                        timeDiff = 1;
                        payAmountTotal = parseFloat(Number(payAmountTotal) + Number(cols[19]*timeDiff)).toFixed(2);

                        payAmount_multiple.push(cols[19]);
                    }
                    else
                    {
                        setDateRangeNumberOfNights(timeDiff);
                        //setGuestPayAmount(parseFloat(cols[19]*timeDiff).toFixed(2));
                        payAmountTotal = parseFloat(Number(payAmountTotal) + Number(cols[19]*timeDiff)).toFixed(2);

                        payAmount_multiple.push(cols[19]);
                    }

                    if(cols[25] == 'N/A')
                    {
                        
                        if(cols[28] == "C" && (parseFloat(cols[19]*timeDiff).toFixed(2) - parseFloat(cols[27]*1).toFixed(2)) == 0.00)
                        {
                            setBookingStatus('bookToCheckIn_depositPaid_multiple');
                            
                            setCheckInInvoice_send('none');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_confirmPaid_non_member('none');
                            setCheckInInvoice_paid('inline-block');
                        }
                        else if(cols[28] == "C" && (parseFloat(cols[19]*timeDiff).toFixed(2) - parseFloat(cols[27]*1).toFixed(2)) > 0.00)
                        {

                            setPartialPaymentStatus(true);
                            setBookingStatus('bookToCheckIn_depositPaid_multiple');

                            setCheckInInvoice_send('inline-block');
                            setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
                        else
                        {
                            setCheckInInvoice_send('inline-block');
                            setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
        
                    }
                    
                    else if(cols[25] == 'PR')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('inline-block');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'R_PC')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('inline-block');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'C')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_confirmPaid_non_member('none');
                        setCheckInInvoice_paid('inline-block');
        
                    }

                                        //roomID: cols[0],
                    //roomType: cols[1],
                    //roomDescription: cols[2],
                    //roomPartNum: cols[3],
                    setConstant_roomPhoneNumber(cols[4]);
                    //address: cols[5],
                    //city: cols[6],
                    //country: cols[7],
                    setConstant_roomSalePrice(cols[8]);
                    //roomPic1: cols[9],
                    //roomPic2: cols[10],
                    //roomPic3: cols[11],
                    //roomPic4: cols[12],
                    //attachment: cols[13],
                    setConstant_roomGuestFirstName(cols[14]);
                    setConstant_roomGuestLastName(cols[15]);
                    setConstant_roomGuestPhoneNumber(cols[16]);
                    setConstant_roomGuestEmail(cols[17]);
                    setConstant_roomGuestPaymentType(cols[18]);
                    //roomGuestPrice: parseFloat(cols[19]).toFixed(2),
                    setConstant_roomGuestCheckInDateBooked(cols[20]);
                    setConstant_roomGuestCheckOutDateBooked(cols[21]);
                    //roomGuestCheckInDateActual: cols[22],
                    setConstant_merchantInvoiceID(cols[23]);
                    setConstant_customerInvoiceID(cols[24]);
                    //setConstant_invoiceSentStatus: cols[25],
                    setConstant_transactionID(cols[26]);
                    setConstant_transactionTotalAmount(parseFloat(cols[27]*1).toFixed(2));
                    //transactionStatus: cols[28],
                    //roomGuestInvoiceAttachment: cols[29],
                    //numOfNights: timeDiff,

                    setViewInventoryBookedRoomDetailData((prevViewInventoryOccupiedRoomDetailData) => {
                        return prevViewInventoryOccupiedRoomDetailData.concat({
                            roomID: cols[0],
                            roomType: cols[1],
                            roomDescription: cols[2],
                            roomPartNum: cols[3],
                            roomPhoneNumber: cols[4],
                            address: cols[5],
                            city: cols[6],
                            country: cols[7],
                            roomSalePrice: cols[8],
                            roomPic1: cols[9],
                            roomPic2: cols[10],
                            roomPic3: cols[11],
                            roomPic4: cols[12],
                            attachment: cols[13],
                            roomGuestFirstName: cols[14],
                            roomGuestLastName: cols[15],
                            roomGuestPhoneNumber: cols[16],
                            roomGuestEmail: cols[17],
                            roomGuestPaymentType: cols[18],
                            roomGuestPrice: parseFloat(cols[19]).toFixed(2),
                            roomGuestCheckInDateBooked: cols[20],
                            roomGuestCheckOutDateBooked: cols[21],
                            roomGuestCheckInDateActual: cols[22],
                            merchantInvoiceID: cols[23],
                            customerInvoiceID: cols[24],
                            invoiceSentStatus: cols[25],
                            transactionID: cols[26],
                            transactionTotalAmount: parseFloat(cols[27]*1).toFixed(2),
                            transactionStatus: cols[28],
                            roomGuestInvoiceAttachment: cols[29],
                            numOfNights: timeDiff,
                        })
                    });
                    setRoomSalePrice(parseFloat(cols[19]).toFixed(2));
                }    

                setRoomID_multiple(roomIDMultiple);
                setGuestPayAmountTotal(payAmountTotal);
                setGuestPayAmount_multiple(payAmount_multiple);
                setDateRangeNumberOfNights_multiple(numOfNights_multiple);
                setBookedStartDate_multiple(checkInDateBooked_multiple);
                setBookedEndDate_multiple(checkOutDateBooked_multiple);
            
            //alert('Booking Date Has been updated to '+e[1]);
            alert(data);

            setShowUpdateCheckOutDateModal(false);
            props.closeModal();

        })
        .catch(error => {
            console.error(error);
        })

    }

    function createInvoice(event)
    {
        /*
        let formData0 = new FormData();
            formData0.append('Tracker', '74706_deposit_multiple');
            formData0.append('user', acctID);
            formData0.append('xCheckInRoomID', event[6]);
            formData0.append('xCheckInRoomID_multiple', props.data.roomID);
            formData0.append('xCheckInFirstName', event[7]);
            formData0.append('xCheckInLastName', event[8]);
            formData0.append('xCheckInMobileNumber', event[9]);
            formData0.append('xCheckInEmail', event[10]);
            //formData0.append('xCheckInNonMemberIDType', checkIn_Non_Member_ID_Type);
            //formData0.append('xCheckInNonMemberIDNumber', enterID_numberRef.current.value);
            formData0.append('xImageFile', checkInAttachment_ID);
            formData0.append('xCheckInNonMemberPaymentType', event[11]);
            formData0.append('xCheckInNonMemberPaymentAmount', parseFloat(event[12]).toFixed(2));
            formData0.append('xCheckInNonMemberPaymentAmount_multiple', guestPayAmount_multiple);
            formData0.append('xCheckInDateBooked', bookedStartDate.toISOString().substr(0, 10));
            formData0.append('xCheckInDateBooked_multiple', bookedStartDate_multiple);
            formData0.append('xCheckOutDateBooked', bookedEndDate.toISOString().substr(0, 10));
            formData0.append('xCheckOutDateBooked_multiple', bookedEndDate_multiple);
            formData0.append('xCheckInNumberOfNights', numOfNights);
            formData0.append('xCheckInNumberOfNights_multiple', numOfNights_multiple);
            formData0.append('xBookingID', props.data.bookingID);
    
            const requestOptions0 = {
                //enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                body: formData0
            }
            */

            const requestOptions0 = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74706_deposit_multiple',
                    user: acctID,
                    xCheckInRoomID: event[6],
                    xCheckInRoomID_multiple: props.data.roomID,
                    xCheckInFirstName: event[7],
                    xCheckInLastName: event[8],
                    xCheckInMobileNumber: event[9],
                    xCheckInEmail: event[10],
                    //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                    //xCheckInNonMemberIDNumber: enterID_numberRef.current.value,
                    xImageFile: checkInAttachment_ID,
                    xCheckInNonMemberPaymentType: event[11],
                    xCheckInNonMemberPaymentAmount: parseFloat(event[12]).toFixed(2),
                    xCheckInNonMemberPaymentAmount_multiple: guestPayAmount_multiple,
                    xCheckInDateBooked: bookedStartDate.toISOString().substr(0, 10),
                    xCheckInDateBooked_multiple: bookedStartDate_multiple,
                    xCheckOutDateBooked: bookedEndDate.toISOString().substr(0, 10),
                    xCheckOutDateBooked_multiple: bookedEndDate_multiple,
                    xCheckInNumberOfNights: numOfNights,
                    xCheckInNumberOfNights_multiple: numOfNights_multiple,
                    xBookingID: props.data.bookingID,
                    sessionID: sessionID,
    
                }),
            }
    
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions0)
            .then(res => res.text())
            .then(data0 => {
    
                let cols = data0.toString().split('|');

                alert('Invoice '+cols[0]+' Created');

    
            })
            .catch(error => {
                console.error(error);
            })
    
    }

    function submitPay(event)
    {

        setDisablePayButton(true);

        if(event[13] == "initial")
        {


            /*
            let formData0 = new FormData();
            formData0.append('Tracker', '74706_deposit_multiple');
            formData0.append('user', acctID);
            formData0.append('xCheckInRoomID', event[6]);
            formData0.append('xCheckInRoomID_multiple', props.data.roomID);
            formData0.append('xCheckInFirstName', event[7]);
            formData0.append('xCheckInLastName', event[8]);
            formData0.append('xCheckInMobileNumber', event[9]);
            formData0.append('xCheckInEmail', event[10]);
            //formData0.append('xCheckInNonMemberIDType', checkIn_Non_Member_ID_Type);
            //formData0.append('xCheckInNonMemberIDNumber', enterID_numberRef.current.value);
            formData0.append('xImageFile', checkInAttachment_ID);
            formData0.append('xCheckInNonMemberPaymentType', event[11]);
            formData0.append('xCheckInNonMemberPaymentAmount', parseFloat(event[12]).toFixed(2));
            formData0.append('xCheckInNonMemberPaymentAmount_multiple', guestPayAmount_multiple);
            formData0.append('xCheckInDateBooked', bookedStartDate.toISOString().substr(0, 10));
            formData0.append('xCheckInDateBooked_multiple', bookedStartDate_multiple);
            formData0.append('xCheckOutDateBooked', bookedEndDate.toISOString().substr(0, 10));
            formData0.append('xCheckOutDateBooked_multiple', bookedEndDate_multiple);
            formData0.append('xCheckInNumberOfNights', numOfNights);
            formData0.append('xCheckInNumberOfNights_multiple', numOfNights_multiple);
            formData0.append('xBookingID', props.data.bookingID);
    
            const requestOptions0 = {
                //enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                body: formData0
            }
            */

            const requestOptions0 = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74706_deposit_multiple',
                    user: acctID,
                    xCheckInRoomID: event[6],
                    xCheckInRoomID_multiple: props.data.roomID,
                    xCheckInFirstName: event[7],
                    xCheckInLastName: event[8],
                    xCheckInMobileNumber: event[9],
                    xCheckInEmail: event[10],
                    //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                    //xCheckInNonMemberIDNumber: enterID_numberRef.current.value,
                    xImageFile: checkInAttachment_ID,
                    xCheckInNonMemberPaymentType: event[11],
                    xCheckInNonMemberPaymentAmount: parseFloat(event[12]).toFixed(2),
                    xCheckInNonMemberPaymentAmount_multiple: guestPayAmount_multiple,
                    xCheckInDateBooked: bookedStartDate.toISOString().substr(0, 10),
                    xCheckInDateBooked_multiple: bookedStartDate_multiple,
                    xCheckOutDateBooked: bookedEndDate.toISOString().substr(0, 10),
                    xCheckOutDateBooked_multiple: bookedEndDate_multiple,
                    xCheckInNumberOfNights: numOfNights,
                    xCheckInNumberOfNights_multiple: numOfNights_multiple,
                    xBookingID: props.data.bookingID,
                    sessionID: sessionID,
    
                }),
            }
    
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions0)
            .then(res => res.text())
            .then(data0 => {
    

                            let cols = data0.toString().split('|');
                            let merchantInvoiceID = cols[0];
                            let customerInvoiceID = cols[1];
                            let internalReferenceID_initial = acctID+"-"+merchantInvoiceID+"-"+customerCheckInPhoneNumber;
                            setInternalReferenceID(internalReferenceID_initial);

                                                    
                                    let xReferenceID = uuid();
                                    //setInternalReferenceID(xReferenceID);

                                    if (paymentTypeRef.current.value == 'cash'|| paymentTypeRef.current.value == 'CASH')
                                    {
                                        //prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value]);
                                        //prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, undefined, undefined,,,,,,,,,,, xReferenceID.toString()]);
                                        prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, undefined, undefined, xReferenceID.toString(),,,,,,,,merchantInvoiceID,customerInvoiceID,internalReferenceID_initial]);
                                        
                                        alert("Payment Type is Cash Confirmed");

                                        return;
                                    }
                                    return new Promise((resolve, reject) => {


                                        const customerPayAmount = parseFloat(event[5]).toFixed(2);
                                        const payCurrency = 'GHS';
                                        //const payExternalId = '';
                                        const payPartyId = event[3].replace(/^0+/, '');
                                        const payPayerMessage = event[7] + " " + event[8] + " Momo Payment";
                                        const payPayeeNote = "Bluefin Hotel Invoice";

                                        const apiuser = "824b5de8-0af9-4757-939b-f50992a0427f";
                                        const apikey = "e288a3938db14c8c9dfe3543427a141e";
                                        const concatenatedString = `${apiuser}:${apikey}`;
                                        const base64EncodedString = window.btoa(concatenatedString);


                                        fetch(baseURL+'mtnapi/collection/token/', {
                                            method: 'POST',                                                                                                                                                                                                                 credentials: 'include',
                                            //mode: 'no-cors',
                                            //body: '',
                                            //Request headers
                                            headers: {
                                                'authorization': 'Basic '+ base64EncodedString,
                                                //'cache-Control': 'no-cache',
                                                //'content-_type': 'application/json',
                                                'ocp-apim-subscription-key': 'c4f861935bb543cbba9f3762cf13fd9e',
                                                'x-target-environment': 'mtnghana',
                                                'x-reference-id': xReferenceID.toString(),
                                                'x-internal-reference-id': internalReferenceID_initial,
                                                'tracker': '74108_B_update_successful',
                                                'user': acctID,
                                                'customer_account_id': 'non_member',
                                                'schema': schema,
                                                'x_project_id': 'N/A',
                                                'x_customer_mobilenumber': event[3],
                                                'x_merchant_mobilenumber': merchantPhoneNumber_mtnMomo.replace(/^0+/, ''),
                                                'x_invoice_id': event[1],
                                                'x_customer_invoice_id': event[2],
                                                'x_immediate_destination': acctID,
                                                'x_check_in_amount': parseFloat(event[5]).toFixed(2),
                                                'session_id': sessionID,
                                                'momo_url': 'collection/v1_0/requesttopay',
                                                'confirm_payment': 'confirm_or_reject',
                                                // 'request_to_pay': JSON.stringify({
                                                //     "amount": customerPayAmount,
                                                //     "currency": payCurrency,
                                                //     "externalId": xReferenceID.toString(),
                                                //     "payer": {
                                                //         "partyIdType": "MSISDN",
                                                //         "partyId": "233"+payPartyId
                                                //     },
                                                //     "payerMessage": payPayerMessage,
                                                //     "payeeNote": payPayeeNote
                                                // }),
                                                'customer_pay_amount': customerPayAmount,
                                                'pay_currency': payCurrency,
                                                'external_id': xReferenceID.toString(),
                                                'party_id_type': 'MSISDN',
                                                'party_id': payPartyId,
                                                'pay_payer_message': payPayerMessage,
                                                'pay_payee_note': payPayeeNote,

                                            },

                                        })
                                        .then(res => res.json())
                                        .then(res => {

                                            prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, 'MTN', res.financialTransactionId, xReferenceID.toString(), res.amount, 'GHS', res.payer.partyIdType, res.payer.partyId, res.payerMessage, res.payeeNote, res.status, merchantInvoiceID, customerInvoiceID, internalReferenceID_initial]);

                                        })
                                    })
                                })
            }
            else
            {


                                                                  
                                    setDisablePayButton(true);
                                    let xReferenceID = uuid();
                                    //setInternalReferenceID(xReferenceID);

                                    if (paymentTypeRef.current.value == 'cash'|| paymentTypeRef.current.value == 'CASH')
                                    {
                                        //prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value]);
                                        //prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, undefined, undefined,,,,,,,,,,, xReferenceID.toString()]);
                                        prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, undefined, undefined, xReferenceID.toString(),,,,,,,,event[1],event[2],internalReferenceID]);

                                        alert("Payment Type is Cash Confirmed");

                                        return;
                                    }
                                    return new Promise((resolve, reject) => {


                                        const customerPayAmount = parseFloat(event[5]).toFixed(2);
                                        const payCurrency = 'GHS';
                                        //const payExternalId = '';
                                        const payPartyId = event[3].replace(/^0+/, '');
                                        const payPayerMessage = event[7] + " " + event[8] + " Momo Payment";
                                        const payPayeeNote = "Bluefin Hotel Invoice";

                                        const apiuser = "824b5de8-0af9-4757-939b-f50992a0427f";
                                        const apikey = "e288a3938db14c8c9dfe3543427a141e";
                                        const concatenatedString = `${apiuser}:${apikey}`;
                                        const base64EncodedString = window.btoa(concatenatedString);


                                        fetch(baseURL+'mtnapi/collection/token/', {
                                            method: 'POST',                                                                                                                                                                                                                 credentials: 'include',
                                            //mode: 'no-cors',
                                            //body: '',
                                            //Request headers
                                            headers: {
                                                'authorization': 'Basic '+ base64EncodedString,
                                                //'cache-Control': 'no-cache',
                                                //'content-_type': 'application/json',
                                                'ocp-apim-subscription-key': 'c4f861935bb543cbba9f3762cf13fd9e',
                                                'x-target-environment': 'mtnghana',
                                                'x-reference-id': xReferenceID.toString(),
                                                'x-internal-reference-id': internalReferenceID,
                                                'tracker': '74108_B_update_successful',
                                                'user': acctID,
                                                'customer_account_id': 'non_member',
                                                'schema': schema,
                                                'x_project_id': 'N/A',
                                                'x_customer_mobilenumber': event[3],
                                                'x_merchant_mobilenumber': merchantPhoneNumber_mtnMomo.replace(/^0+/, ''),
                                                'x_invoice_id': event[1],
                                                'x_customer_invoice_id': event[2],
                                                'x_immediate_destination': acctID,
                                                'x_check_in_amount': parseFloat(event[5]).toFixed(2),
                                                'session_id': sessionID,
                                                'momo_url': 'collection/v1_0/requesttopay',
                                                'confirm_payment': 'confirm_or_reject',
                                                // 'request_to_pay': JSON.stringify({
                                                //     "amount": customerPayAmount,
                                                //     "currency": payCurrency,
                                                //     "externalId": xReferenceID.toString(),
                                                //     "payer": {
                                                //         "partyIdType": "MSISDN",
                                                //         "partyId": "233"+payPartyId
                                                //     },
                                                //     "payerMessage": payPayerMessage,
                                                //     "payeeNote": payPayeeNote
                                                // }),
                                                'customer_pay_amount': customerPayAmount,
                                                'pay_currency': payCurrency,
                                                'external_id': xReferenceID.toString(),
                                                'party_id_type': 'MSISDN',
                                                'party_id': payPartyId,
                                                'pay_payer_message': payPayerMessage,
                                                'pay_payee_note': payPayeeNote,

                                            },

                                        })
                                        .then(res => res.json())
                                        .then(res => {

                                            prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, 'MTN', res.financialTransactionId, xReferenceID.toString(), res.amount, 'GHS', res.payer.partyIdType, res.payer.partyId, res.payerMessage, res.payeeNote, res.status, event[1], event[2]], internalReferenceID);

                                        })
                                    })
            }
    }

    function submitPay_refund(event)
    {

        setDisablePayButton(true);

        if (paymentTypeRef.current.value == 'CASH')
        {
            refund([event, paymentTypeRef.current.value]);

            //alert("Payment Type is Cash Confirmed");

            return;
        }
        return new Promise((resolve, reject) => {


            const customerPayAmount = parseFloat(event[5]).toFixed(2);
            const payCurrency = 'GHS';
            //const payExternalId = '';
            const payPartyId = event[3].replace(/^0+/, '');
            const payPayerMessage = event[7] + " " + event[8] + " Momo Payment";
            const payPayeeNote = "Bluefin Hotel Invoice";

            const apiuser = "28fd26ad-0cda-49a2-ad90-15083276a26a";
            const apikey = "218c665182e447538d0e6ac6f36ad3b4";
            const concatenatedString = `${apiuser}:${apikey}`;
            const base64EncodedString = window.btoa(concatenatedString);

            let referenceIdToRefund = "";
            if (event[10] == 'refund') {
                referenceIdToRefund = event[9];
            }

            let xReferenceID = uuid();

            let body_refund = {
                "amount": customerPayAmount,
                "currency": payCurrency,
                "externalId": xReferenceID.toString(),
                "payerMessage": payPayerMessage,
                "payeeNote": payPayeeNote,
                "referenceIdToRefund": referenceIdToRefund,
            }
            let body_transfer = {
                "amount": customerPayAmount,
                "currency": payCurrency,
                "externalId": xReferenceID.toString(),
                "payer": {
                    "partyIdType": "MSISDN",
                    "partyId": "233"+payPartyId
                },
                "payerMessage": payPayerMessage,
                "payeeNote": payPayeeNote
            }

            let body_deposit = {
                "amount": customerPayAmount,
                "currency": payCurrency,
                "externalId": xReferenceID.toString(),
                "payer": {
                    "partyIdType": "MSISDN",
                    "partyId": "233"+payPartyId
                },
                "payerMessage": payPayerMessage,
                "payeeNote": payPayeeNote
            }

            let fetch_body;

            if(event[10] == 'refund')
            {
                alert("In Refund"); 
                fetch_body = body_refund;
            }
            else if(event[10] == 'transfer')
            {
                alert("In transfer"); 
                fetch_body = body_transfer;
            }
            else if(event[10] == 'deposit')
            {
                alert("In deposit"); 
                fetch_body = body_deposit;
            }

            fetch(baseURL+'mtnapi/disbursement/token/', {
                method: 'POST',                                                                                                                                                                                                                 
                //credentials: 'include',
                //mode: 'no-cors',
                //body: '',
                //Request headers
                headers: {
                    'authorization': 'Basic '+ base64EncodedString,
                    //'cache-Control': 'no-cache',
                    //'content-_type': 'application/json',
                    'ocp-apim-subscription-key': 'ff1585eb2f8a41d29771cca4238c02d3',
                    'x-target-environment': 'mtnghana',
                    'x-reference-id': xReferenceID.toString(),
                    'user': acctID,
                    'customer_account_id': 'non_member',
                    'x_project_id': 'N/A',
                    'x_customer_mobilenumber': event[3],
                    'x_merchant_mobilenumber': merchantPhoneNumber_mtnMomo.replace(/^0+/, ''),
                    'x_invoice_id': event[1],
                    'x_customer_invoice_id': event[2],
                    'x_immediate_destination': acctID,
                    'x_check_in_amount': parseFloat(event[5]).toFixed(2),
                    'session_id': sessionID,
                    'momo_url': 'disbursement/v1_0/'+event[10],
                    'confirm_payment': 'confirm_or_reject',
                    // 'request_to_pay': JSON.stringify({
                    //     "amount": customerPayAmount,
                    //     "currency": payCurrency,
                    //     "externalId": xReferenceID.toString(),
                    //     "payer": {
                    //         "partyIdType": "MSISDN",
                    //         "partyId": "233"+payPartyId
                    //     },
                    //     "payerMessage": payPayerMessage,
                    //     "payeeNote": payPayeeNote
                    // }),
                    'customer_pay_amount': customerPayAmount,
                    'pay_currency': payCurrency,
                    'external_id': xReferenceID.toString(),
                    'party_id_type': 'MSISDN',
                    'party_id': payPartyId,
                    'pay_payer_message': payPayerMessage,
                    'pay_payee_note': payPayeeNote,

                },
                body: JSON.stringify(fetch_body),


            })
            .then(res => res.json())
            .then(res => {

                alert('AFTER submitPay_refund');
                alert(res);

                refund([event, paymentTypeRef.current.value, 'MTN', res.financialTransactionId, res.externalId, res.amount, 'GHS', res.payee.partyIdType, res.payee.partyId, res.payerMessage, res.payeeNote, res.status]);

            })
        })
    }


    function prepareInvoice_thenConfirmPay_nonMember(event)
    {


        // if(event[0][13] == "partial_paid")
        // {
        //     /*
        //     let formData = new FormData();
        //     formData.append('Tracker', '74108_B');
        //     formData.append('user', acctID);
        //     formData.append('xCustMobileNumber', event[3]);
        //     formData.append('xInvoiceID', event[1]);
        //     formData.append('xCustomerInvoiceID', event[2]);
        //     formData.append('xImmediateDestination', acctID);
        //     formData.append('xCheckInCashAmount', parseFloat(event[5]).toFixed(2));


        //     const requestOptions = {
        //         //enctype: 'multipart/form-data',
        //         method:'POST',
        //         credentials: 'include',
        //         body: formData
        //     }
        //     */

        //     const requestOptions = {
        //         method: 'POST',
        //         //credentials: 'include',
        //         headers: {
        //             'Accept': 'text/html, application/json',
        //             'content-type': 'application/json',
        //             //'cookie': 'cookie',
        //         },
        //         body: JSON.stringify({
        //             Tracker: '74108_B',
        //             user: acctID,
        //             xCustMobileNumber: event[0][3],
        //             xInvoiceID: event[0][1],
        //             xCustomerInvoiceID: event[0][2],
        //             xImmediateDestination: acctID,
        //             xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
        //             sessionID: sessionID,
        //             xPaymentType: event[1],
        //             xMomo_provider: event[2],
        //             xMomo_financial_transaction_id: event[3],
        //             xMomo_external_id: event[4],
        //             xMomo_amount: event[5],
        //             xMomo_currency: event[6],
        //             xmomo_party_id_type: event[7],
        //             xMomo_party_id: event[8],
        //             xMomo_payer_message: event[9],
        //             xMomo_payee_note: event[10],
        //             xMomo_pay_status: event[11],
        //             xInternalReferenceID: internalReferenceID,

        //         }),
        //     }

        //     fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        //     .then(res => res.text())
        //     .then(data => {

        //         confirmPayment_non_member([data, event[0][1], event[0][2], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], event[4], event[5], event[6], event[7], event[8], event[9], event[10], event[11]]);

        //     })
        //     .catch(error => {
        //         console.error(error);
        //     })

        // }
        // else if(event[0][13] == "initial")
        // {


        //     /*
        //     let formData0 = new FormData();
        //     formData0.append('Tracker', '74706_deposit_multiple');
        //     formData0.append('user', acctID);
        //     formData0.append('xCheckInRoomID', event[6]);
        //     formData0.append('xCheckInRoomID_multiple', props.data.roomID);
        //     formData0.append('xCheckInFirstName', event[7]);
        //     formData0.append('xCheckInLastName', event[8]);
        //     formData0.append('xCheckInMobileNumber', event[9]);
        //     formData0.append('xCheckInEmail', event[10]);
        //     //formData0.append('xCheckInNonMemberIDType', checkIn_Non_Member_ID_Type);
        //     //formData0.append('xCheckInNonMemberIDNumber', enterID_numberRef.current.value);
        //     formData0.append('xImageFile', checkInAttachment_ID);
        //     formData0.append('xCheckInNonMemberPaymentType', event[11]);
        //     formData0.append('xCheckInNonMemberPaymentAmount', parseFloat(event[12]).toFixed(2));
        //     formData0.append('xCheckInNonMemberPaymentAmount_multiple', guestPayAmount_multiple);
        //     formData0.append('xCheckInDateBooked', bookedStartDate.toISOString().substr(0, 10));
        //     formData0.append('xCheckInDateBooked_multiple', bookedStartDate_multiple);
        //     formData0.append('xCheckOutDateBooked', bookedEndDate.toISOString().substr(0, 10));
        //     formData0.append('xCheckOutDateBooked_multiple', bookedEndDate_multiple);
        //     formData0.append('xCheckInNumberOfNights', numOfNights);
        //     formData0.append('xCheckInNumberOfNights_multiple', numOfNights_multiple);
        //     formData0.append('xBookingID', props.data.bookingID);
    
        //     const requestOptions0 = {
        //         //enctype: 'multipart/form-data',
        //         method:'POST',
        //         credentials: 'include',
        //         body: formData0
        //     }
        //     */

        //     const requestOptions0 = {
        //         method: 'POST',
        //         //credentials: 'include',
        //         headers: {
        //             'Accept': 'text/html, application/json',
        //             'content-type': 'application/json',
        //             //'cookie': 'cookie',
        //         },
        //         body: JSON.stringify({
        //             Tracker: '74706_deposit_multiple',
        //             user: acctID,
        //             xCheckInRoomID: event[0][6],
        //             xCheckInRoomID_multiple: props.data.roomID,
        //             xCheckInFirstName: event[0][7],
        //             xCheckInLastName: event[0][8],
        //             xCheckInMobileNumber: event[0][9],
        //             xCheckInEmail: event[0][10],
        //             //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
        //             //xCheckInNonMemberIDNumber: enterID_numberRef.current.value,
        //             xImageFile: checkInAttachment_ID,
        //             xCheckInNonMemberPaymentType: event[0][11],
        //             xCheckInNonMemberPaymentAmount: parseFloat(event[0][12]).toFixed(2),
        //             xCheckInNonMemberPaymentAmount_multiple: guestPayAmount_multiple,
        //             xCheckInDateBooked: bookedStartDate.toISOString().substr(0, 10),
        //             xCheckInDateBooked_multiple: bookedStartDate_multiple,
        //             xCheckOutDateBooked: bookedEndDate.toISOString().substr(0, 10),
        //             xCheckOutDateBooked_multiple: bookedEndDate_multiple,
        //             xCheckInNumberOfNights: numOfNights,
        //             xCheckInNumberOfNights_multiple: numOfNights_multiple,
        //             xBookingID: props.data.bookingID,
        //             sessionID: sessionID,
    
        //         }),
        //     }
    
        //     fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions0)
        //     .then(res => res.text())
        //     .then(data0 => {
    

        //                     let cols = data0.toString().split('|');

                           /*
                            let formData = new FormData();
                            formData.append('Tracker', '74108_B');
                            formData.append('user', acctID);
                            formData.append('xCustMobileNumber', event[3]);
                            //formData.append('xInvoiceID', event[1]);
                            formData.append('xInvoiceID', cols[0]);
                            //formData.append('xCustomerInvoiceID', event[2]);
                            formData.append('xCustomerInvoiceID', cols[1]);
                            formData.append('xImmediateDestination', acctID);
                            formData.append('xCheckInCashAmount', parseFloat(event[5]).toFixed(2));
    
    
                            const requestOptions = {
                                //enctype: 'multipart/form-data',
                                method:'POST',
                                credentials: 'include',
                                body: formData
                            }
                            */


                            const requestOptions = {
                                method: 'POST',
                                //credentials: 'include',
                                headers: {
                                    'Accept': 'text/html, application/json',
                                    'content-type': 'application/json',
                                    //'cookie': 'cookie',
                                },
                                body: JSON.stringify({
                                    Tracker: '74108_B',
                                    user: acctID,
                                    xCustMobileNumber: event[0][3],
                                    xInvoiceID: event[12],
                                    xCustomerInvoiceID: event[13],
                                    xImmediateDestination: acctID,
                                    xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                                    sessionID: sessionID,
                                    xPaymentType: event[1],
                                    xMomo_provider: event[2],
                                    xMomo_financial_transaction_id: event[3],
                                    xMomo_external_id: event[4],
                                    xMomo_amount: event[5],
                                    xMomo_currency: event[6],
                                    xmomo_party_id_type: event[7],
                                    xMomo_party_id: event[8],
                                    xMomo_payer_message: event[9],
                                    xMomo_payee_note: event[10],
                                    xMomo_pay_status: event[11],  
                                    xInternalReferenceID: event[14],

                                }),
                            }
    
                            fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
                            .then(res => res.text())
                            .then(data => {


                                confirmPayment_non_member([data, event[0][1], event[13], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], event[4], event[5], event[6], event[7], event[8], event[9], event[10], event[11], event[14]]);

    
                            })
                            .catch(error => {
                                console.error(error);
                            })
    
        

    }

    function merchant_nonMember_update_transaction_status(event)
    {


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74108_B_update',
                user: acctID,
                xCustMobileNumber: event[0][3],
                xInvoiceID: event[0][1],
                xCustomerInvoiceID: event[0][2],
                xImmediateDestination: acctID,
                xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                sessionID: sessionID,
                xMomo_provider: event[1],
                xMomo_financial_transaction_id: event[2],
                xMomo_external_id: event[3],
                xMomo_amount: event[4],
                xMomo_currency: event[5],
                xmomo_party_id_type: event[6],
                xMomo_party_id: event[7],
                xMomo_payer_message: event[8],
                xMomo_payee_note: event[9],
                xMomo_pay_status: event[10],
                xInternalReferenceID: internalReferenceID,

            }),
        }


        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

        })
        .catch(error => {
            console.error(error);
        })
    }

    function refund(event)
    {

        alert('In refund');
        alert(event);
        setDisableRefundButton(true);

        /*let formData = new FormData();
        formData.append('Tracker', '74108_B_refund');
        formData.append('user', acctID);
        formData.append('xCustMobileNumber', event[3]);
        formData.append('xInvoiceID', event[1]);
        formData.append('xCustomerInvoiceID', event[2]);
        formData.append('xImmediateDestination', acctID);
        formData.append('xCheckInCashAmount', parseFloat(event[5]).toFixed(2));


        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }*/
        
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74108_B_refund',
                user: acctID,
                xCustMobileNumber: event[0][3],
                xInvoiceID: event[0][1],
                xCustomerInvoiceID: event[0][2],
                xImmediateDestination: acctID,
                xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                sessionID: sessionID,
                xPaymentType: event[1],
                xMomo_provider: event[2],
                xMomo_financial_transaction_id: event[3],
                xMomo_external_id: event[4],
                xMomo_amount: event[5],
                xMomo_currency: event[6],
                xmomo_party_id_type: event[7],
                xMomo_party_id: event[8],
                xMomo_payer_message: event[9],
                xMomo_payee_note: event[10],
                xMomo_pay_status: event[11], 
                xInternalReferenceID: internalReferenceID,

            }),
        }


        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            confirmPayment_non_member([data, event[0][1], event[0][2], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], event[4], event[5], event[6], event[7], event[8], event[9], event[10], event[11]]);

        })
        .catch(error => {
            console.error(error);
        })
    }


    function confirmPayment_non_member(event)
    {

        let tracker = event[4];
        let customerInvoiceID = event[2];
        let transactionID = event[0];
        let customerPhoneNumber = event[3];

        /*
        let formData = new FormData();
        formData.append('Tracker', tracker);
        formData.append('xCustomerInvoiceID', customerInvoiceID);
        formData.append('xTransactionID', transactionID);
        formData.append('xCustMobileNumber', customerPhoneNumber);
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[5]);
        formData.append('xBookingID', props.data.bookingID);

        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: tracker,
                user: acctID,
                fmc_schema: schema,
                baseUrl: baseURL,
                xCustomerInvoiceID: customerInvoiceID,
                xTransactionID: transactionID,
                xCustMobileNumber: customerPhoneNumber,
                xCheckInRoomID: event[5],
                xBookingID: props.data.bookingID,
                sessionID: sessionID,
                xPaymentType: event[6],
                xMomo_provider: event[7],
                xMomo_financial_transaction_id: event[8],
                xMomo_external_id: event[9],
                xMomo_amount: event[10],
                xMomo_currency: event[11],
                xmomo_party_id_type: event[12],
                xMomo_party_id: event[13],
                xMomo_payer_message: event[14],
                xMomo_payee_note: event[15],
                xMomo_pay_status: event[16], 
                xInternalReferenceID: event[17],

            }),
        }


        

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {


            //setDisablePayButton(false);

            if (data == 'confirmed')
            {
                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('none');
                setCheckInInvoice_paid('inline-block');

                alert('Client Payment Confirmed');
            }
            else if(data == 'confirmed_partial')
            {

                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('inline-block');
                setCheckInInvoice_paid('none');

                alert('Client Partial Payment Confirmed');

            }
            else if (data == 'confirmed_refund')
            {
                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('none');
                setCheckInInvoice_paid('inline-block');

                alert('Client Full refund Confirmed');
            }
            else if(data == 'confirmed_partial_refund')
            {

                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('inline-block');
                setCheckInInvoice_paid('none');

                alert('Client Partial Refund Confirmed');

            }
            else
            {
                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_paid('none');

                alert('Payment Sent To Customer');
            }

            props.closeModal();
        })
    }

    function checkInModalHandler(event)
    {
        setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
        setBookedFirstName(event[3]);
        setBookedLastName(event[4]);
        setBookedPhoneNumber(event[5]);
        setBookedEmail(event[6]);

        setBookedStartDate(event[7]);
        setBookedEndDate(event[8]);

        setCheckInModal(event[0]);
    }
    function handleUpdate_checkInDate(event)
    {

        setBookedStartDate(event[1]);
        setBookedEndDate(event[2]);
        setRoomID_current(event[3]);
        setShowUpdateCheckInDateModal(event[0]);
    }
    function handleUpdate_checkOutDate(event)
    {

        setBookedStartDate(event[1]);
        setBookedEndDate(event[2]);
        setRoomID_current(event[3]);
        setShowUpdateCheckOutDateModal(event[0]);
    }

    function refund(event)
    {
        setDisableRefundButton(true);

        /*
        let formData = new FormData();
        formData.append('Tracker', '74108_B_refund');
        formData.append('user', acctID);
        formData.append('xCustMobileNumber', event[3]);
        formData.append('xInvoiceID', event[1]);
        formData.append('xCustomerInvoiceID', event[2]);
        formData.append('xImmediateDestination', acctID);
        formData.append('xCheckInCashAmount', parseFloat(event[5]).toFixed(2));


        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74108_B_refund',
                user: acctID,
                xCustMobileNumber: event[0][3],
                xInvoiceID: event[0][1],
                xCustomerInvoiceID: event[0][2],
                xImmediateDestination: acctID,
                xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                sessionID: sessionID,
                xMomo_provider: event[1],
                xMomo_financial_transaction_id: event[2],
                xMomo_external_id: event[3],
                xMomo_amount: event[4],
                xMomo_currency: event[5],
                xmomo_party_id_type: event[6],
                xMomo_party_id: event[7],
                xMomo_payer_message: event[8],
                xMomo_payee_note: event[9],
                xMomo_pay_status: event[10], 
                xInternalReferenceID: internalReferenceID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            confirmPayment_non_member([data, event[0][1], event[0][2], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], event[4], event[5], event[6], event[7], event[8], event[9], event[10]]);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function deleteBooking(enteredPassword)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', 74193);
        formData.append('user', acctID);
        formData.append('xInventoryRoomID', props.data.roomID);
        formData.append('xBookingID', props.data.bookingID);
        formData.append('xEnterAdminPassword', enteredPassword);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74193',
                user: acctID,
                xInventoryRoomID: props.data.roomID,
                xBookingID: props.data.bookingID,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

        })

        props.closeModal(false);

    }


    function applyDiscount_total(event, newRoomSalePrice)
    {
        // alert("in apply Discount");
        // alert(event);
        // alert(newRoomSalePrice);

        /*let formData = new FormData();
        formData.append('Tracker', '7999_delete');
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[0]);
        formData.append('xCustomerInvoiceID', event[1]);

        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74112_applyDiscount_booking_multiple',
                user: acctID,
                xCheckInRoomID: event[0],
                xInvoiceID: event[1],
                xCustomerInvoiceID: event[2],
                xCheckInNumberOfNights: numOfNights,
                xCheckInNonMemberPaymentAmount: newRoomSalePrice,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            setViewInventoryBookedRoomDetailData([]);
            props.closeModal(false);
            
        })
        .catch(error => {
            console.error(error);
        })
    }

    function handleAdd_room(event)
    {

        setBookedStartDate(event[1]);
        setBookedEmail(event[2]);
        setShowAddBookedRoomModal(event[0]);
    }

    function handleUpdate_room(event)
    {

        setBookedStartDate(event[1]);
        setBookedEmail(event[2]);
        setRoomID_current(event[3]);
        setShowUpdateBookedRoomModal(event[0]);
    }

    function viewInvoiceModalHandler(event) {

        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        setRoomGuestInvoiceAttachment(event[3]);
        setViewInvoiceModal(event[0]);

    }

    function setDepositHandler()
    {
        setDisableSetButton(true);
        setDisplaySetButton('none');
        //setRoomSalePrice(props.data.roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
        setDisableResetButton(false);
        setDisplayResetButton('inline-block');

    }

    function resetDepositHandler()
    {
        setDisableResetButton(true);
        setDisplayResetButton('none');
        //setRoomSalePrice(props.data.roomSalePrice);
        enterDepositRef.current.value = '';
        setDisableSetButton(false);
        setDisplayResetButton('none');
        setDisplaySetButton('inline-block');
    }


    function setDiscountHandler(event)
    {

        // alert(event);
        // alert(constant_roomSalePrice);
        // alert(enterIncreaseRef.current.value);
        // alert(enterDiscountRef.current.value);
        // alert(checkInRoomID_multiple);
        // alert(guestPayAmount_multiple[0]);
        // alert(guestPayAmount_multiple[1]);
        // alert(guestPayAmount_multiple[2]);
        // alert(guestPayAmount_multiple[3]);

        if(enterIncreaseRef.current.value > 0)
        {
            setDisableSetButton(true);
            setDisplaySetButton('none');
            setDisplayResetButton('inline-block');
            setRoomSalePrice(constant_roomSalePrice + (constant_roomSalePrice*(enterIncreaseRef.current.value/100)));
           // setBookingPrice(roomSalePrice + (roomSalePrice*(enterIncreaseRef.current.value/100)));
            setDisableResetButton(false);
    
            let newRoomSalesPrice_Multiple = [];

            if(roomID_multiple != null)
            {    
                for(let i = 0; i < guestPayAmount_multiple.length; ++i)
                {
                    newRoomSalesPrice_Multiple.push(guestPayAmount_multiple[i] + (guestPayAmount_multiple[i]*(enterIncreaseRef.current.value/100)));

                   // alert('GREATER THAN 0')
                    //alert(guestPayAmount_multiple[i]);

                }

                
                setRoomSalePrice_multiple(newRoomSalesPrice_Multiple);

                //alert('GREATER THAN 1')
               // alert(newRoomSalesPrice_Multiple);
            }

            applyDiscount_total(event, newRoomSalesPrice_Multiple);

        }
        else
        {
            setDisableSetButton(true);
            setDisplaySetButton('none');
            setDisplayResetButton('inline-block');
            setRoomSalePrice(constant_roomSalePrice - (constant_roomSalePrice*(enterDiscountRef.current.value/100)));
            //setBookingPrice(roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
            setDisableResetButton(false);
    
            let newRoomSalesPrice_Multiple = [];

            if(roomID_multiple != null)
            {    
                for(let i = 0; i < guestPayAmount_multiple.length; ++i)
                {
                    newRoomSalesPrice_Multiple.push(guestPayAmount_multiple[i] - (guestPayAmount_multiple[i]*(enterDiscountRef.current.value/100)));
                    //alert('GREATER THAN A')
                    //alert(guestPayAmount_multiple[i]);
                }
                
                setRoomSalePrice_multiple(newRoomSalesPrice_Multiple);
                //alert('GREATER THAN B')
                //alert(newRoomSalesPrice_Multiple);

            }

            applyDiscount_total(event, newRoomSalesPrice_Multiple);

        }
    }
    
    function resetDiscountHandler(event)
    {
        setDisableResetButton(true);
        setDisplaySetButton('inline-block');
        setDisplayResetButton('none');
        setRoomSalePrice(event);
        enterDiscountRef.current.value = 0;
        enterIncreaseRef.current.value = 0;
        setDisableSetButton(false);
    }


    function setRefundHandler()
    {
        setDisableSetButton_refund(true);
        setDisplaySetButton_refund('none');
        //setRoomSalePrice(props.data.roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
        setDisableResetButton_refund(false);
        setDisplayResetButton_refund('inline-block');

    }

    function resetRefundHandler()
    {
        setDisableResetButton_refund(true);
        setDisplayResetButton_refund('none');
        //setRoomSalePrice(props.data.roomSalePrice);
        enterRefundRef.current.value = '';
        setDisableSetButton_refund(false);
        setDisplayResetButton_refund('none');
        setDisplaySetButton_refund('inline-block');
    }

    function deletBookingHandler(event)
    {
        setShowPasswordModal(true);

    }
    function onSubmitPasswordHandler_refund(event)
    {
        refund();
    }
    function onSubmitPasswordHandler(event)
    {

        deleteBooking(event);
    }
    function closeModalHandler() {

        props.closeModal();
    }

    function closeModalHandler_checkIn() {

        setRoomSalePrice(null);
        setCheckInModal(false);
        props.closeModal();
    }


    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader style={{color: "black"}}>
            <IonGrid >
                <IonRow>
                    <IonCol size='12'>
                        <h3>ROOMS BOOKED - MULTIPLE</h3>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='6'> All Rooms </IonCol>
                    <IonCol size='6'> Total Invoice</IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='6'> {props.data.roomID} </IonCol>
                    <IonCol size='6'> {parseFloat(guestPayAmountTotal).toFixed(2)} </IonCol>
                </IonRow>
            </IonGrid>
        </IonHeader>

        <IonContent className='gridContent_multiple_top'>
            <IonSlides pager='true' options={{direction: 'horizontal'}}>
            {viewInventoryBookedRoomDetailData.map((detailData) =>   {
            return (
            <IonSlide>
            <IonGrid className='gridContent_multiple_top_grid'>
                <IonRow>
                    <IonCol size='12'>
                        Room ID: {detailData.roomID}
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Category</IonCol>
                    <IonCol size='6' >Value</IonCol>
                    <IonCol size='3' >Action</IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' > Invoice ID </IonCol>
                    <IonCol size='6' >{detailData.merchantInvoiceID}</IonCol>
                    {detailData.merchantInvoiceID == 'booking_non_member' && <IonCol size='3' > <IonButton > - </IonButton>
                        {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton id='gridResultColumnButton' disabled={disablePayButton} style={{display: checkInInvoice_confirmPaid_non_member}} onClick={() => createInvoice([constant_transactionID, constant_merchantInvoiceID, constant_customerInvoiceID, constant_roomGuestPhoneNumber, '74605_B_bookDeposit', '0.00', constant_roomID, constant_roomGuestFirstName, constant_roomGuestLastName, constant_roomGuestPhoneNumber, constant_roomGuestEmail, constant_roomGuestPaymentType, guestPayAmountTotal])}> Create </IonButton>}
                     </IonCol>}
                    {detailData.merchantInvoiceID != 'booking_non_member' && <IonCol size='3' > 
                        <IonButton onClick={() => viewInvoiceModalHandler([true, detailData.roomID, detailData.roomSalePrice, detailData.roomGuestInvoiceAttachment])}> View </IonButton> 
                    </IonCol>}
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Changerelative Room</IonCol>
                    <IonCol size='6' >{ 'ID: '+detailData.roomID+
                                                        'Part Number: '+detailData.roomPartNum}</IonCol>
                    <IonCol size='3' >
                    {detailData.merchantInvoiceID == 'booking_non_member' && <IonButton > - </IonButton>}
                    {detailData.merchantInvoiceID != 'booking_non_member' && <IonButton onClick={() => handleUpdate_room([true, detailData.roomGuestCheckInDateBooked, detailData.roomGuestCheckOutDateBooked, detailData.roomID])} > Update </IonButton>}
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Room Images</IonCol>
                    <IonCol size='6' >{detailData.roomType}</IonCol>
                    <IonCol size='3' >
                        <ShowRoomPicsModal openModal={ roomPicsModal } closeModal={() => setRoomPicsModal(false)} data={{
                        roomPic1: detailData.roomPic1, 
                        roomPic2: detailData.roomPic2, 
                        roomPic3: detailData.roomPic3, 
                        roomPic4: detailData.roomPic4, 
                        roomID: detailData.roomID, 
                        roomSalePrice: detailData.roomSalePrice
                        }}></ShowRoomPicsModal>
                        <IonButton onClick={() => setRoomPicsModal(true)}> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Check-In Date</IonCol>
                    <IonCol size='6' >{detailData.roomGuestCheckInDateBooked}</IonCol>
                    <IonCol size='3' >
                        <IonButton disabled={disableCheckInButton} onClick={() => handleUpdate_checkInDate([true, detailData.roomGuestCheckInDateBooked, detailData.roomGuestCheckOutDateBooked, detailData.roomID])} > Update </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Check-Out Date</IonCol>
                    <IonCol size='6' >{detailData.roomGuestCheckOutDateBooked}</IonCol>
                    <IonCol size='3' >
                        <IonButton disabled={disableCheckOutButton} onClick={() => handleUpdate_checkOutDate([true, detailData.roomGuestCheckInDateBooked, detailData.roomGuestCheckOutDateBooked, detailData.roomID])} > Update </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' ># of Nights</IonCol>
                    <IonCol size='6' >{detailData.numOfNights}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Guest Contact</IonCol>
                    <IonCol size='6' >{ 'Name: '+detailData.roomGuestFirstName+' '+detailData.roomGuestLastName+
                                                        'Phone Number: '+detailData.roomGuestPhoneNumber+
                                                        'Email: '+detailData.roomGuestEmail}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Guest Room Price</IonCol>
                    <IonCol size='6' >{detailData.roomGuestPrice}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Guest Payment Type</IonCol>
                    <IonCol size='6' >{detailData.roomGuestPaymentType}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Room Total</IonCol>
                    <IonCol size='6' >{parseFloat((detailData.roomGuestPrice * detailData.numOfNights)).toFixed(2)}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
            </IonSlide>
                    )
                }
            )}
            
            </IonSlides>

            <IonGrid className='gridContent_multiple_bottom'>
                <IonRow >
                    <IonCol size='3' >Deposit Paid</IonCol>
                    <IonCol size='6' >{constant_transactionTotalAmount}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='4'>
                        <h4>Discount: </h4>
                    </IonCol>
                    <IonCol size='4'>
                        <IonInput style={{display: displaySetButton}} type='number' placeholder='Enter %' ref={enterDiscountRef}></IonInput>
                        <h4 style={{display: displayResetButton}}>{(( ( constant_originaloRoomPriceTotal - guestPayAmountTotal )/ (constant_originaloRoomPriceTotal)) * 100).toFixed(2)+' %'}</h4>
                    </IonCol>
                    <IonCol size='4'> 
                        <IonButton style={{display: displaySetButton}} disabled={disableSetButton} onClick={() => setDiscountHandler([constant_roomID, constant_merchantInvoiceID, constant_customerInvoiceID])}>Set</IonButton>
                        <IonButton style={{display: displayResetButton}} disabled={disableResetButton} onClick={() => resetDiscountHandler(constant_roomSalePrice)}>Reset</IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Balance</IonCol>
                    <IonCol size='6' >{(parseFloat(guestPayAmountTotal) + parseFloat(constant_transactionTotalAmount)).toFixed(2)}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='3'>
                        Deposit
                    </IonCol>
                    <IonCol size='3'>
                        <IonInput style={{display: displaySetButton}} type='number' placeholder='Enter %' ref={enterDepositRef}></IonInput>
                        <h4 style={{display: displayResetButton}}>{enterDepositRef.current.value+' GH'}</h4>
                    </IonCol>
                    <IonCol size='3'>
                        <IonButton style={{display: displaySetButton}} disabled={disableSetButton} onClick={() => setDepositHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton}} disabled={disableResetButton} onClick={() => resetDepositHandler()}>Reset</IonButton>
                    </IonCol>
                    <IonCol>
                        <select name="payemntType" id='payemntType' ref={paymentTypeRef }>
                            <option value='CASH'>Cash</option>
                            <option value='MTN-MOMO' selected>Mobile Money</option>
                        </select>
                    </IonCol>
                    <IonCol  size='3'>
                        <IonButton style={{display: checkInInvoice_sent}} > Pending Payment/View Sent </IonButton>
                        {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager' || authenticatedMerchent_context.accessRights[0] == 'front_desk') && (momo_pay_status_db == '' || momo_pay_status_db == 'NO_RESPONSE' || momo_pay_status == 'FAILED' || momo_pay_status_db == 'N/A') && momo_pay_status_db != 'CASH') && <IonButton id='gridResultColumnButton'  disabled={disablePayButton} onClick={() => submitPay([constant_transactionID, constant_merchantInvoiceID, constant_customerInvoiceID, constant_roomGuestPhoneNumber, '74605_B_bookDeposit', enterDepositRef.current.value, constant_roomID, constant_roomGuestFirstName, constant_roomGuestLastName, constant_roomGuestPhoneNumber, constant_roomGuestEmail, constant_roomGuestPaymentType, guestPayAmountTotal, 'initial'])}> PAY </IonButton>}
                        {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager' || authenticatedMerchent_context.accessRights[0] == 'front_desk') && (momo_pay_status_db == 'PENDING' || momo_pay_status_db == 'CREATED')) && <IonButton id='gridResultColumnButton' disabled={true} > PENDING </IonButton>}
                        {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager' || authenticatedMerchent_context.accessRights[0] == 'front_desk') && (momo_pay_status_db == 'SUCCESSFUL' || momo_pay_status_db == 'CASH')) && <IonButton id='gridResultColumnButton'  disabled={disablePayButton} onClick={() => submitPay([constant_transactionID, constant_merchantInvoiceID, constant_customerInvoiceID, constant_roomGuestPhoneNumber, '74605_B_bookDeposit', enterDepositRef.current.value, constant_roomID, constant_roomGuestFirstName, constant_roomGuestLastName, constant_roomGuestPhoneNumber, constant_roomGuestEmail, constant_roomGuestPaymentType, guestPayAmountTotal, 'partial_paid'])}> Pay </IonButton>}

                        
                        <p style={{display: checkInInvoice_paid}}> Payment Confirmed </p>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Add Room</IonCol>
                    <IonCol size='3' >
                    {(authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager' || authenticatedMerchent_context.accessRights[0] == 'front_desk') && <IonButton onClick={() => setShowAddBookedRoomModal(true)} > Add </IonButton>}
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol>
                        <IonButton onClick={() => checkInModalHandler([true, constant_roomID, constant_roomSalePrice, constant_roomGuestFirstName, constant_roomGuestLastName, constant_roomGuestPhoneNumber, constant_roomGuestEmail, constant_roomGuestCheckInDateBooked, constant_roomGuestCheckOutDateBooked])} > Check-In Guest </IonButton>
                    </IonCol>
                    {(authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') &&
                    <IonCol>
                        {(constant_merchantInvoiceID == 'booking_non_member' || constant_transactionTotalAmount == 0.00) && <IonButton onClick={() => setShowPasswordModal(true)}> Delete Booking </IonButton>}
                    </IonCol>
                    }
                    {(authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') &&
                    <IonCol>
                        {(constant_merchantInvoiceID != 'booking_non_member' || constant_transactionTotalAmount > 0.00) && <IonButton onClick={() => setShowPasswordModal(true)}> Delete Paid Booking </IonButton>}
                    </IonCol>
                    }
                </IonRow>
                {authenticatedMerchent_context.accessRights[0] == 'admin' &&
                <IonRow>
                    <IonCol size='3'>
                        REFUND
                    </IonCol>
                    <IonCol size='3'>
                        <IonInput style={{display: displaySetButton_refund}} type='number' placeholder='Enter %' ref={enterRefundRef}></IonInput>
                        <h4 style={{display: displayResetButton_refund}}>{enterRefundRef.current.value+' GH'}</h4>
                    </IonCol>
                    <IonCol size='3'>
                        <IonButton style={{display: displaySetButton_refund}} disabled={disableSetButton_refund} onClick={() => setRefundHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton_refund}} disabled={disableResetButton_refund} onClick={() => resetRefundHandler()}>Reset</IonButton>
                    </IonCol>
                    <IonCol size='3'>
                        {constant_merchantInvoiceID != 'booking_non_member' && <IonButton id='gridResultColumnButton' disabled={disableRefundButton} onClick={() => submitPay_refund([constant_transactionID, constant_merchantInvoiceID, constant_customerInvoiceID, constant_roomGuestPhoneNumber, '74605_B_bookDeposit_refund', enterRefundRef.current.value, constant_roomID, constant_roomGuestFirstName, constant_roomGuestLastName, constant_momo_external_id, 'refund'])}> Refund </IonButton>}
                        {constant_merchantInvoiceID != 'booking_non_member' && <IonButton id='gridResultColumnButton' disabled={disableRefundButton} onClick={() => submitPay_refund([constant_transactionID, constant_merchantInvoiceID, constant_customerInvoiceID, constant_roomGuestPhoneNumber, '74605_B_bookDeposit_refund', enterRefundRef.current.value, constant_roomID, constant_roomGuestFirstName, constant_roomGuestLastName, constant_momo_external_id, 'transfer'])}> Transfer </IonButton>}
                        {constant_merchantInvoiceID != 'booking_non_member' && <IonButton id='gridResultColumnButton' disabled={disableRefundButton} onClick={() => submitPay_refund([constant_transactionID, constant_merchantInvoiceID, constant_customerInvoiceID, constant_roomGuestPhoneNumber, '74605_B_bookDeposit_refund', enterRefundRef.current.value, constant_roomID, constant_roomGuestFirstName, constant_roomGuestLastName, constant_momo_external_id, 'deposit'])}> Deposit </IonButton>}                    
                    </IonCol>
                </IonRow>
                }
            </IonGrid>


            <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>
            <EnterPasswordModal openModal={ showPasswordModal_refund } closeModal={() => setShowPasswordModal_refund(false)} onSubmitPassword={ onSubmitPasswordHandler_refund }></EnterPasswordModal>

            {checkInModal == true && <EnterCheckInInfoModal openModal={ checkInModal } closeModal={() => closeModalHandler_checkIn()} onCheckInRoomID_multiple={{selectedRoomID: roomID_multiple, selectedRoomSalesPrice: guestPayAmount_multiple}} data={{
                        status: bookingStatus,
                        roomID: roomID, 
                        roomSalePrice: guestPayAmountTotal,
                        bookedFirstName: bookedFirstName, 
                        bookedLastName: bookedLastName,
                        bookedPhoneNumber: bookedPhoneNumber,
                        bookedEmail: bookedEmail,
                        bookedStartDate: bookedStartDate,
                        bookedEndDate: bookedEndDate,
                        bookingID: props.data.bookingID
                        }}></EnterCheckInInfoModal>}

            {showInvoiceModal == true && <ViewInvoiceModal openModal={ showInvoiceModal } closeModal={() => setViewInvoiceModal(false)} data={{
                                        fileLocation: roomGuestInvoiceAttachment, 
                                        roomID: roomID, 
                                        roomSalePrice: roomSalePrice,
                                        }}></ViewInvoiceModal>}

            {showAddBookedRoomModal == true && <AddRoomBookedModal openModal={ showAddBookedRoomModal } closeModal={() => setShowAddBookedRoomModal(false)} startDate={new Date(bookedStartDate).toISOString().substr(0, 10)} endDate={new Date(bookedEndDate).toISOString().substr(0, 10)} checkInRoomID_multiple={roomID_multiple} reference_roomID={roomID_current}  bookingID={props.data.bookingID}></AddRoomBookedModal>}

            {showUpdateBookedRoomModal == true && <UpdateRoomBookedModal openModal={ showUpdateBookedRoomModal } closeModal={() => setShowUpdateBookedRoomModal(false)} startDate={new Date(bookedStartDate).toISOString().substr(0, 10)} endDate={new Date(bookedEndDate).toISOString().substr(0, 10)} currentRoom={roomID_current} currentRoom_multiple={props.data.roomID} bookingID={props.data.bookingID}></UpdateRoomBookedModal>}

            {showUpdateCheckInDateModal == true && <UpdateCheckInDateModal openModal={ showUpdateCheckInDateModal } closeModal={() => setShowUpdateCheckInDateModal(false)} onSubmitNewDate={onSubmitNewDateHandler}></UpdateCheckInDateModal>}

            {showUpdateCheckOutDateModal == true && <UpdateCheckOutDateModal openModal={ showUpdateCheckOutDateModal } closeModal={() => setShowUpdateCheckOutDateModal(false)} onSubmitNewDate={onSubmitNewDateHandler}></UpdateCheckOutDateModal>}


            </IonContent>
            <IonFooter className='appFooter'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="12">
                            <IonButton className='button_closeModal_center' onClick={closeModalHandler}> Close </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </IonModal>) : null}
    </React.Fragment>
    )
}